(() => {
  const dialog = document.getElementById('cs-p5-dialog');
  if (!dialog) return;
  const form = document.getElementById('cs-p5-contact');
  const size = document.getElementById('cs-p5-size');
  let context, opener;
  const options = panel => { try { return JSON.parse(panel.querySelector('[data-cs-p5-options]').textContent); } catch { return []; } };
  function sync() {
    if (!context) return;
    const url = new URL(context.url, location.origin);
    url.searchParams.set('variant', size.value);
    document.getElementById('cs-p5-url').value = url.href;
    document.getElementById('cs-p5-size-label').value = size.selectedOptions[0]?.textContent || ''; 
    const body = ['Board: '+context.title, 'Size: '+size.selectedOptions[0]?.textContent, 'Page: '+url.href, 'Name: '+document.getElementById('cs-p5-name').value, 'Email: '+document.getElementById('cs-p5-email').value, document.getElementById('cs-p5-message').value].join('\n');
    dialog.querySelector('[data-cs-p5-mail]').href='mailto:'+dialog.dataset.email+'?'+new URLSearchParams({subject:'Phase 5 pre-order enquiry: '+context.title,body});
  }
  function populate(data) {
    context=data; document.getElementById('cs-p5-model').value=data.title;
    size.replaceChildren(...data.options.filter(o=>o.waiting).map(o=>{const node=new Option(o.title,o.id);node.selected=o.id===data.selected;return node;}));sync();
  }
  function update(panel, id) {
    if (panel.classList.contains('cs-p5-card')) {
      const opts=options(panel), action=panel.querySelector('[data-cs-p5-card-action]');
      if (opts.length && opts.every(o=>o.waiting)) {if(action.textContent!==dialog.dataset.button)action.textContent=dialog.dataset.button;action.setAttribute('data-cs-p5-open','');action.setAttribute('aria-haspopup','dialog');}
      return;
    }
    const productForm=panel.parentElement.querySelector('product-form');
    const current=String(id || productForm?.querySelector('[name=id]')?.value || panel.dataset.selected);
    const variant=options(panel).find(o=>o.id===current);
    panel.dataset.selected=current;panel.hidden=!variant?.waiting;
    productForm?.toggleAttribute('data-p5-hide',!!variant?.waiting);
  }
  const init=()=>document.querySelectorAll('[data-cs-p5]').forEach(p=>update(p));
  document.addEventListener('change',event=>{
    if(event.target.matches('input[name=id]')) event.target.closest('product-info')?.querySelectorAll('[data-cs-p5]').forEach(p=>update(p,event.target.value));
  });
  document.addEventListener('submit',event=>{
    const productForm=event.target.closest('product-form[data-p5-hide]');
    if(productForm){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-cs-p5-open]');if(!trigger)return;
    const panel=trigger.closest('[data-cs-p5]');if(!panel)return;
    const opts=options(panel);if(!opts.some(o=>o.waiting))return;
    event.preventDefault();opener=trigger;
    populate({title:panel.dataset.product,url:panel.dataset.url,selected:trigger.dataset.variant||panel.dataset.selected,options:opts});
    dialog.querySelector('[data-cs-p5-fields]').hidden=false;dialog.querySelector('[data-cs-p5-mail]').hidden=false;dialog.querySelector('[data-cs-p5-success]')?.remove();dialog.showModal();
  });
  form.addEventListener('input',sync);form.addEventListener('change',sync);
  form.addEventListener('submit',()=>{if(context)try{sessionStorage.setItem('cs-p5-pending',JSON.stringify({...context,selected:size.value,time:Date.now()}));}catch{}});
  dialog.addEventListener('close',()=>opener?.focus());
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  let pending;try{pending=JSON.parse(sessionStorage.getItem('cs-p5-pending')||'null');}catch{}
  if(pending && Date.now()-pending.time<1800000 && dialog.querySelector('[data-cs-p5-success],[data-cs-p5-error]')){
    populate(pending);if(dialog.querySelector('[data-cs-p5-success]')){dialog.querySelector('[data-cs-p5-fields]').hidden=true;dialog.querySelector('[data-cs-p5-mail]').hidden=true;try{sessionStorage.removeItem('cs-p5-pending');}catch{}}dialog.showModal();
  }
  let scheduled=false;new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;init();});}).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',init);init();
})();
